// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ul":"ul-1F43DCU8","last":"last-7w0JGEMM ul-1F43DCU8"};